export default {"src":"/_next/static/image/public/images/CaretRight.554a12be2c77e6ce7dea553a041b225f.svg","height":24,"width":24};